import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import formatError from "../../services/FormatError";
import { sortList } from "./Users";
import { dateFormatter } from "./BuyerProfile";
import {
  fetchAllContracts,
  fetchContractDetails,
  fetchContractsPerBusiness,
  fetchContractsPerProfile,
  sendContractReminder,
} from "../../services/ContractsService";
import { useTranslation } from "react-i18next";

function Contracts() {
  const { t } = useTranslation();

  const ctxObj = JSON.parse(sessionStorage.getItem("userDetails"))?.result;

  const businessId = useLocation()?.state;

  const state = useSelector((state) => state.auth.auth.result);

  const [contractsData, setContractsData] = useState({
    original: [],
    filtered: [],
  });

  const [gridFilter, setGridFilter] = useState("");

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [viewContract, setViewContract] = useState({
    cond: false,
    data: {},
  });

  useEffect(() => {
    if (businessId === null) {
      getAllContracts();
    } else {
      getContractsPerBusiness();
    }
  }, [businessId, state, tableParams.current, tableParams.pageSize]);

  const getAllContracts = () => {
    if (
      ctxObj?.loggedinprofiletype === "buyerprofile" ||
      ctxObj?.loggedinprofiletype === "sellerprofile"
    ) {
      fetchContractsPerProfile(ctxObj?.loggedinprofileid)
        .then((res) => {
          const response = res.data?.result;

          const responseData = response?.length > 0 ? sortList(response) : [];

          setContractsData({
            original: responseData,
            filtered: responseData,
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.length,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else if (ctxObj?.role?.id === 1 || ctxObj?.role?.id === 2) {
      fetchAllContracts()
        .then((res) => {
          const response = res.data?.result;

          const responseData =
            response?.data?.length > 0 ? sortList(response?.data) : [];

          setContractsData({
            original: responseData,
            filtered: responseData,
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.count,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    }
  };

  const getContractsPerBusiness = () => {
    fetchContractsPerBusiness(businessId)
      .then((res) => {
        const response = res.data?.result;

        const responseData = response?.length > 0 ? sortList(response) : [];

        setContractsData({
          original: responseData,
          filtered: responseData,
        });

        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: response?.length,
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateGridData = (value) => {
    setGridFilter(value);

    if (value !== "") {
      const filteredData = contractsData.original.filter((item) =>
        item?.contractname.toLowerCase().includes(value.toLowerCase())
      );

      setContractsData((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setContractsData((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const onViewContract = (id) => {
    fetchContractDetails(id)
      .then((res) => {
        const response = res?.data?.result;

        setViewContract({
          cond: true,
          data: response,
        });
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onBack = () => {
    setViewContract({
      cond: false,
      data: {},
    });
  };

  const onViewFile = (base64) => {
    let pdfWindow = window.open("");
    pdfWindow.document.write(
      "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(base64) +
        "'></iframe>"
    );
  };

  const onDownloadFile = (base64, contractName) => {
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${base64}`;
    link.download = contractName;
    link.click();
  };

  const onSendReminder = (contractId) => {
    sendContractReminder(contractId)
      .then((res) => {})
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const columns = [
    {
      title: "S.NO",
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: `${t("buyerProfileCulumn2")}`,
      dataIndex: "contractname",
      sorter: true,
      width: "20%",
      render: (obj, record) => {
        return (
          <>
            <span className="text-muted">{obj}</span>
            <br />
            <span className=" fw-bold fs-16">
              {record?.contractbusinessname}
            </span>
          </>
        );
      },
    },
    // {
    //   title: t("status"),
    //   dataIndex: "iscompleted",
    //   width: "20%",
    //   render: (obj,record) => {
    //     return (
    //       <>
    //         {record?.iscompleted === false ? "" : <span>${t("completed")}</span>}
    //         {record?.isdeleted === false ? "" : <span>${t("hdelete")}</span>}

    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Is Deleted",
    //   dataIndex: "isdeleted",
    //   width: "20%",
    //   render: (obj) => {
    //     return (
    //       <>
    //         <span>{obj === false ? "False" : "True"}</span>
    //       </>
    //     );
    //   },
    // },
    {
      title: `${t("buyerDetailsCreatedDate")}`,
      dataIndex: "createdat",
      width: "20%",
      render: (text) => dateFormatter(text),
    },
    {
      title: `${t("hexpiryDate")}`,
      dataIndex: "expirationDate",
      width: "20%",
      render: (text) => dateFormatter(text),
    },
    {
      title: `${t("sellerProfileCulumn7")}`,
      dataIndex: "actions",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              style={{ fontSize: "15px", marginRight: "8px" }}
              onClick={() => onViewContract(record?.id)}
            >
              <i className="fa fa-eye"></i>
            </a>
          </div>
        );
      },
      width: "20%",
    },
  ];

  return (
    <>
      {viewContract?.cond ? (
        <div className="col-lg-12">
          <div className="card project-card">
            <div class="card-header d-sm-flex d-block">
              <div class="d-flex me-auto mb-sm-0" onClick={onBack}>
                <span
                  style={{ fontSize: "18px" }}
                  className="d-flex justify-content-start align-items-center me-3"
                >
                  <i className="fa fa-arrow-left"></i>
                </span>
                <h4 class="card-title">{t("hcontractDetails")}</h4>
              </div>
            </div>

            <div className="card-body">
              <div className="d-flex mb-4 align-items-start">
                <div className="me-auto">
                  <h5 className="title font-w600 mb-2">
                    {t("hcontractDetails")}
                  </h5>
                </div>
                <div className="d-flex align-items-start">
                  {(ctxObj?.loggedinprofiletype === "sellerprofile" ||
                    ctxObj?.loggedinprofiletype === "buyerprofile") && (
                    <button
                      type="button"
                      style={{
                        height: "32px",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                      }}
                      className="btn btn-primary me-3"
                      onClick={() => onSendReminder(viewContract?.data?.id)}
                    >
                      {t("hreminder")}
                    </button>
                  )}
                  <button
                    type="button"
                    style={{
                      height: "32px",
                      paddingTop: "0px",
                      paddingBottom: "0px",
                    }}
                    className="btn btn-success me-3"
                    onClick={() =>
                      onViewFile(viewContract?.data?.originalcontractbase64)
                    }
                  >
                    {t("hviewFile")}
                  </button>
                  <button
                    type="button"
                    style={{
                      height: "32px",
                      paddingTop: "0px",
                      paddingBottom: "0px",
                    }}
                    className="btn btn-warning me-3"
                    onClick={() =>
                      onDownloadFile(
                        viewContract?.data?.originalcontractbase64,
                        viewContract?.data?.contractname
                      )
                    }
                  >
                    {t("hdownloadFile")}
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 mb-sm-0">
                  <p>
                    {t("nameInput")}: {viewContract?.data?.contractname}
                  </p>
                  <p>
                    {t("hcontractHash")}: {viewContract?.data?.contracthash}
                  </p>
                  <p>Is Completed: {`${viewContract?.data?.iscompleted}`}</p>
                </div>
                <div className="col-sm-6 mb-sm-0">
                  <p>
                    {t("businessDetailsCreatedDate")}:{" "}
                    {dateFormatter(viewContract?.data?.createdat)}
                  </p>
                  <p>
                    {t("hexpiryDate")}:{" "}
                    {dateFormatter(viewContract?.data?.expirationDate)}
                  </p>
                  <p>Is Deleted: {`${viewContract?.data?.isdeleted}`}</p>
                </div>
              </div>

              <hr />

              {/* Recipient Details */}
              <div className="d-flex mb-4 align-items-start">
                <div className="me-auto">
                  <h5 className="title font-w600 mb-2">
                    {t("hrecipientDetails")}
                  </h5>
                </div>
              </div>

              {viewContract?.data?.recipents.map((item) => (
                <div key={`recipient${item?.id}`} className="row">
                  <div className="col-sm-6 mb-sm-0 mb-3">
                    <p>
                      {t("nameInput")}: {item?.name}
                    </p>
                    <p>
                      {t("signUpEmailInput")}: {item?.email}
                    </p>
                    <p>
                      {t("roleInput")}: {item?.role}
                    </p>
                  </div>
                  <div className="col-sm-6 mb-sm-0 mb-3">
                    <p>
                      {t("hlanguage")}: {item?.language}
                    </p>
                    <p>
                      {t("hmessage")}: {item?.message}
                    </p>
                    <p>
                      {t("businessDetailsCreatedDate")}: {item?.createdat}
                    </p>
                  </div>
                </div>
              ))}

              <hr />

              {/* Signer Details */}
              <div className="d-flex mb-4 align-items-start">
                <div className="me-auto">
                  <h5 className="title font-w600 mb-2">
                    {t("hsignerDetails")}
                  </h5>
                </div>
              </div>

              {viewContract?.data?.signers?.length > 0 &&
                viewContract?.data?.signers.map((item) => (
                  <div key={`signers${item?.id}`} className="row mb-1">
                    <div className="col-sm-6 mb-sm-0 mb-3">
                      <p>
                        {t("nameInput")}: {item?.name}
                      </p>
                      <p>
                        {t("emailInput")}: {item?.email}
                      </p>
                      <p>
                        {t("hlanguage")}: {item?.language}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ) : (
        <div class="card">
          <div class="card-header d-sm-flex d-block">
            <div class="d-flex me-auto mb-sm-0">
              <h4 class="card-title">{t("sidebarItemContracts")}</h4>
            </div>
            <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
          </div>

          <div class="card-body">
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={contractsData.filtered}
              pagination={tableParams}
              onChange={handleTableChange}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Contracts;
